import { render, staticRenderFns } from "./AddNewFile.vue?vue&type=template&id=2d8c39b1&"
import script from "./AddNewFile.vue?vue&type=script&lang=js&"
export * from "./AddNewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports